/* eslint-disable */
// @ts-nocheck
import React from "react";
import { alpha } from "@mui/material/styles";
import { BORDER_RADIUS_SM } from "../../theme/theme";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  MenuItem,
  Box,
  FormControlLabel,
  Switch,
  Button,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Collapse,
  IconButton,
  Typography,
  Chip,
  Alert,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  PersonAdd as PersonAddIcon,
  Delete,
  Add as AddIcon,
} from "@mui/icons-material";

const UserFormDialog = ({
  openModalUser,
  setOpenModalForUser,
  editingUser,
  form,
  setForm,
  userErrors,
  handleChangeForUser,
  showAddUserPassword,
  setShowAddUserPassword,
  login,
  organisationList,
  proratedAmount,
  userForms,
  setEmailDuplicateWarnings,
  userFormsErrors,
  emailDuplicateWarnings,
  isUserCardExpanded,
  toggleUserCard,
  removeUserEntry,
  updateUserEntry,
  checkEmailDuplicate,
  addUserEntry,
  addUserError,
  handleSubmitUser,
  userSubmitting,
}: any) => {
  return (
    <Dialog
      open={openModalUser}
      onClose={() => setOpenModalForUser(false)}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>{editingUser ? "Edit User" : "Add User"}</DialogTitle>
      <DialogContent sx={{ pt: 1, overflowY: "auto", maxHeight: "78vh" }}>
        {/* ── EDIT MODE: single-user form ── */}
        {editingUser && (
          <Grid container spacing={2} mt={1}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="First Name"
                value={form.firstName}
                onChange={(e) =>
                  handleChangeForUser("firstName", e.target.value)
                }
                error={!!userErrors.firstName}
                helperText={userErrors.firstName}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Last Name"
                value={form.lastName}
                onChange={(e) =>
                  handleChangeForUser("lastName", e.target.value)
                }
                error={!!userErrors.lastName}
                helperText={userErrors.lastName}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={form.email}
                onChange={(e) =>
                  handleChangeForUser("email", e.target.value)
                }
                error={!!userErrors.email}
                helperText={userErrors.email}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Phone"
                value={form.phone}
                onChange={(e) =>
                  handleChangeForUser("phone", e.target.value)
                }
                error={!!userErrors.phone}
                helperText={userErrors.phone}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Mobile"
                value={form.mobile}
                onChange={(e) =>
                  handleChangeForUser("mobile", e.target.value)
                }
                error={!!userErrors.mobile}
                helperText={userErrors.mobile}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                label="Role"
                value={form.role}
                onChange={(e) =>
                  handleChangeForUser("role", e.target.value)
                }
                error={!!userErrors.role}
                helperText={userErrors.role}
              >
                <MenuItem value="user">User</MenuItem>
                {(login?.data?.role === "global admin" ||
                  login?.data?.role === "orgadmin") && (
                  <MenuItem value="orgadmin">Organisation Admin</MenuItem>
                )}
                {(login?.data?.role === "global admin" ||
                  form.role === "global admin") && (
                  <MenuItem value="global admin">Global Admin</MenuItem>
                )}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                label="Status"
                value={form.status}
                onChange={(e) =>
                  handleChangeForUser("status", e.target.value)
                }
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Password"
                type={showAddUserPassword ? "text" : "password"}
                value={form.password}
                onChange={(e) =>
                  handleChangeForUser("password", e.target.value)
                }
                error={!!userErrors.password}
                helperText={userErrors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowAddUserPassword((v) => !v)}
                        edge="end"
                        size="small"
                      >
                        {showAddUserPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.twoFactorEnabled}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        twoFactorEnabled: e.target.checked,
                      }))
                    }
                    color="primary"
                  />
                }
                label="Enable Two-Factor Authentication (2FA)"
              />
            </Grid>
          </Grid>
        )}

        {/* ── ADD MODE: multi-user accordion ── */}
        {!editingUser &&
          (() => {
            const orgId =
              form.orgId ||
              (login?.data?.role === "orgadmin"
                ? login?.data?.orgId
                : "");
            const inviteOrg = organisationList?.find(
              (org) => org._id === orgId,
            );
            const isPaidOrg =
              inviteOrg?.billingStatus === "active" &&
              !inviteOrg?.isBillingExempt;
            return (
              <Box sx={{ pt: 1 }}>
                {/* Organisation selector — global admins only */}
                {login?.data?.role === "global admin" && (
                  <FormControl
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <InputLabel id="org-select-label">
                      Select Organisation
                    </InputLabel>
                    <Select
                      labelId="org-select-label"
                      value={form.orgId}
                      onChange={(e) =>
                        handleChangeForUser("orgId", e.target.value)
                      }
                      label="Select Organisation"
                      error={!!userErrors.orgId}
                    >
                      {organisationList?.map((org) => (
                        <MenuItem key={org._id} value={org._id}>
                          {org.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText error>
                      {userErrors.orgId}
                    </FormHelperText>
                  </FormControl>
                )}

                {/* Proration banner */}
                {isPaidOrg && proratedAmount && (() => {
                  const manualCount = userForms.filter((f) => f.manualPassword).length;
                  const inviteCount = userForms.filter((f) => !f.manualPassword).length;
                  const total = userForms.length;
                  const planLabel = proratedAmount.billingInterval === "year" ? "Yearly" : "Monthly";
                  const currency = proratedAmount.currency?.toUpperCase();
                  const rawAmount = Math.abs(proratedAmount.amount);
                  // API is always called with total count — derive per-seat from the response
                  const fetchedCount = proratedAmount.count || total || 1;
                  const perSeat = rawAmount / fetchedCount;
                  const manualAmount = `${(perSeat * manualCount).toFixed(2)} ${currency}`;
                  const inviteAmount = `${(perSeat * inviteCount).toFixed(2)} ${currency}`;
                  const perSeatAmount = `${perSeat.toFixed(2)} ${currency}`;

                  let message: React.ReactNode;
                  if (manualCount > 0 && inviteCount > 0) {
                    message = (
                      <>
                        Adding <strong>{total} users</strong> to your <strong>{planLabel} Plan</strong>
                        {" — "}
                        <strong>{manualCount}</strong> with admin-set password: <strong>{manualAmount}</strong> charged to your card immediately (prorated for remaining days in this billing cycle).{" "}
                        <strong>{inviteCount}</strong> via invite link: <strong>{inviteAmount}</strong> will be charged once {inviteCount === 1 ? "they accept" : "each accepts"} and activates their account — no charge until then.
                      </>
                    );
                  } else if (manualCount > 0) {
                    message = (
                      <>
                        Adding <strong>{manualCount} user{manualCount !== 1 ? "s" : ""}</strong> to your <strong>{planLabel} Plan</strong> with admin-set
                        password{manualCount !== 1 ? "s" : ""}. <strong>{manualAmount}</strong> will be charged to your card immediately,
                        prorated for the remaining days in this billing cycle.
                      </>
                    );
                  } else {
                    message = (
                      <>
                        Adding <strong>{inviteCount} user{inviteCount !== 1 ? "s" : ""}</strong> to your <strong>{planLabel} Plan</strong> via invite
                        link{inviteCount !== 1 ? "s" : ""}. <strong>No charge now</strong> — approximately <strong>{perSeatAmount}</strong> per seat will be charged once each user accepts their invite and activates their account.
                      </>
                    );
                  }
                  return (
                    <Alert severity="info" sx={{ mb: 2, borderRadius: BORDER_RADIUS_SM }}>
                      {message}
                    </Alert>
                  );
                })()}

                {/* Per-user accordion cards */}
                {userForms.map((entry, idx) => {
                  const errs = userFormsErrors[idx] || {};
                  const warn = emailDuplicateWarnings[idx] || "";
                  const isExpanded = isUserCardExpanded(idx);
                  const displayName =
                    `${entry.firstName} ${entry.lastName}`.trim() ||
                    `User ${idx + 1}`;
                  const isReady = !!(
                    entry.firstName &&
                    entry.lastName &&
                    entry.email &&
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(entry.email) &&
                    entry.role &&
                    !warn &&
                    (!entry.manualPassword || entry.password)
                  );

                  return (
                    <Box
                      key={idx}
                      sx={{
                        border: `1px solid`,
                        borderColor: isReady ? "success.light" : "divider",
                        borderRadius: "10px",
                        mb: 1.5,
                        overflow: "hidden",
                        transition: "border-color 200ms",
                      }}
                    >
                      {/* Card header */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          px: 1.5,
                          py: 0.75,
                          bgcolor: (theme) =>
                            alpha(theme.palette.primary.main, 0.03),
                          cursor: "pointer",
                          userSelect: "none",
                        }}
                        onClick={() => toggleUserCard(idx)}
                      >
                        <PersonAddIcon
                          fontSize="small"
                          color="action"
                          sx={{ mr: 1, flexShrink: 0 }}
                        />
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          sx={{
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {displayName}
                          {entry.email ? ` — ${entry.email}` : ""}
                        </Typography>
                        {isReady && (
                          <Chip
                            label="Ready"
                            size="small"
                            color="success"
                            variant="outlined"
                            sx={{
                              mr: 0.75,
                              height: 18,
                              fontSize: "0.68rem",
                              flexShrink: 0,
                            }}
                          />
                        )}
                        {userForms.length > 1 && (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeUserEntry(idx);
                            }}
                            sx={{ mr: 0.25 }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        )}
                        <IconButton size="small">
                          {isExpanded ? (
                            <ExpandLessIcon fontSize="small" />
                          ) : (
                            <ExpandMoreIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Box>

                      {/* Card body */}
                      <Collapse in={isExpanded}>
                        <Box
                          sx={{
                            p: 1.5,
                            borderTop: 1,
                            borderColor: "divider",
                          }}
                        >
                          <Grid container spacing={1.25}>
                            <Grid item xs={6}>
                              <TextField
                                required
                                label="First Name"
                                fullWidth
                                size="small"
                                value={entry.firstName}
                                onChange={(e) =>
                                  updateUserEntry(
                                    idx,
                                    "firstName",
                                    e.target.value,
                                  )
                                }
                                error={!!errs.firstName}
                                helperText={errs.firstName}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                required
                                label="Last Name"
                                fullWidth
                                size="small"
                                value={entry.lastName}
                                onChange={(e) =>
                                  updateUserEntry(
                                    idx,
                                    "lastName",
                                    e.target.value,
                                  )
                                }
                                error={!!errs.lastName}
                                helperText={errs.lastName}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                required
                                label="Email"
                                fullWidth
                                size="small"
                                type="email"
                                value={entry.email}
                                onChange={(e) => {
                                  updateUserEntry(
                                    idx,
                                    "email",
                                    e.target.value,
                                  );
                                  setEmailDuplicateWarnings((p) =>
                                    p.map((w, i) => (i === idx ? "" : w)),
                                  );
                                }}
                                onBlur={() =>
                                  checkEmailDuplicate(idx, entry.email)
                                }
                                error={!!errs.email || !!warn}
                                helperText={
                                  errs.email || warn || undefined
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                label="Phone"
                                fullWidth
                                size="small"
                                value={entry.phone}
                                onChange={(e) =>
                                  updateUserEntry(
                                    idx,
                                    "phone",
                                    e.target.value,
                                  )
                                }
                                error={!!errs.phone}
                                helperText={errs.phone || "Optional"}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                select
                                required
                                label="Role"
                                fullWidth
                                size="small"
                                value={entry.role}
                                onChange={(e) =>
                                  updateUserEntry(
                                    idx,
                                    "role",
                                    e.target.value,
                                  )
                                }
                                error={!!errs.role}
                                helperText={errs.role}
                              >
                                <MenuItem value="user">User</MenuItem>
                                {(login?.data?.role === "global admin" ||
                                  login?.data?.role === "orgadmin") && (
                                  <MenuItem value="orgadmin">
                                    Organisation Admin
                                  </MenuItem>
                                )}
                                {login?.data?.role === "global admin" && (
                                  <MenuItem value="global admin">
                                    Global Admin
                                  </MenuItem>
                                )}
                              </TextField>
                            </Grid>
                            <Grid item xs={12}>
                              <FormControlLabel
                                sx={{
                                  pl: 1.5,
                                }}
                                control={
                                  <Switch
                                    checked={entry.manualPassword}
                                    onChange={(e) =>
                                      updateUserEntry(
                                        idx,
                                        "manualPassword",
                                        e.target.checked,
                                      )
                                    }
                                    color="primary"
                                    size="small"
                                  />
                                }
                                label={
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      pl: 1,
                                    }}
                                  >
                                    Set password manually (skip invitation
                                    email)
                                  </Typography>
                                }
                              />
                            </Grid>
                            {entry.manualPassword && (
                              <Grid item xs={12}>
                                <TextField
                                  required
                                  label="Password"
                                  fullWidth
                                  size="small"
                                  type="password"
                                  value={entry.password}
                                  onChange={(e) =>
                                    updateUserEntry(
                                      idx,
                                      "password",
                                      e.target.value,
                                    )
                                  }
                                  error={!!errs.password}
                                  helperText={errs.password}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </Collapse>
                    </Box>
                  );
                })}

                {/* Add another user */}
                <Button
                  startIcon={<AddIcon />}
                  size="small"
                  variant="outlined"
                  color="inherit"
                  onClick={addUserEntry}
                  sx={{ mt: 0.5 }}
                >
                  Add another user
                </Button>

                {addUserError && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    {addUserError}
                  </Alert>
                )}
              </Box>
            );
          })()}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenModalForUser(false)}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmitUser}
          disabled={userSubmitting}
          endIcon={
            userSubmitting ? (
              <CircularProgress size={16} color="inherit" />
            ) : null
          }
        >
          {editingUser
            ? "Update"
            : userForms.length > 1
              ? `Create ${userForms.length} Users`
              : "Create User"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserFormDialog;
